import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext';

/**
 * Abre o editor de foto (o `AvatarModal` global) na própria página (AJH-48). Não precisa avisar quem chamou:
 * a foto nova muda a chave da coleção de selos, que é relida sozinha (`useColecaoDeSelos`).
 */
export function useAtualizarFoto() {
  const { user } = useAuth();
  const { showModal } = useModal();

  return () => showModal('avatar', { config: user?.extra?.avatar });
}
